import React, { useState, useEffect } from "react";

export default function CreateProduct(props: any) {
  const [productNumber, setProductNumber] = useState('');
  const [option1, setOption1] = useState('');
  const [response, setResponse] = useState('');
  const [quantity, setQuantity] = useState(50);
  const [error, setError] = useState('');

  const createProduct = async () => {
    await createProductPost(props.collection);
    setResponse("did it");
  }

  const onProductNumberChange = (event: any) => {
    setProductNumber(event.target.value);
  }

  const onOption1Change = (event: any) => {
    setOption1(event.target.value);
  }

  const createProductPost = async ( collection: number) => {
    try {
      const response = await fetch('https://dev-rms2.cleverapps.se/api/assortmentplanning/budgetproducts', {
        method: 'POST',
        headers: {
          "X-Cleverapps-Tenant": "int2",
          "Authorization": "2cb6f1fbde9548fe86a75d86a77ba43d",
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          Department: "A.Dept",
          ProductNumber: productNumber,
          Option1: option1,
          Brand: "A.Brand",
          Collection: collection,
          Period: 1,
          Category: "A.Category",
          Supplier: "A.Supplier"
        })
      });
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      setError('');
    } catch (err: any) {
      setError(err.message);
    }
  }


  return (
    <div>
        <p>Collection: {props.collection}</p>
      <label>Product Number:
        <input type="text" value={productNumber} onChange={onProductNumberChange}/>
      </label>
      
      <label>Option1:
        <input type="text" value={option1} onChange={onOption1Change}/>
      </label>
      <button onClick={createProduct}>Create Product</button>
    </div>
  );
}